module.exports = __webpack_public_path__ + "icons/cross.f7259644bf81531483b9421480255d39.svg";